import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { riskToleranceOptions } from '@app/forms/subscription/services/ref';

@Component({
    selector: 'risk-profil-third-part',
    templateUrl: './risk-profil-third-part.component.html',
    styleUrls: ['./risk-profil-third-part.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class RiskProfilThirdPartComponent implements OnInit {
  @Input() derrors = false;
  options: FormControlOption[] = riskToleranceOptions;
  constructor() {}

  ngOnInit() {}
}
